export function formatPrice(price: number | null) {
  return price ? new Intl.NumberFormat('ru-RU').format(price) : 0
}

export function calculateAverage(numbers: number[]): number {
  if (numbers.length === 0) {
    return 0
  }

  const sum = numbers.reduce((acc, num) => acc + num, 0)
  return sum / numbers.length
}
